module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/instagram-white-6ecf8e80ebda43dfaca3be90d98fa5a7.svg";